import { joinClasses } from '@/utils/styling';

export default function Card({ 
    children,
    className = '',
    flat = false
} : { 
    children: React.ReactNode 
    className?: string,
    flat?: boolean
}) {
    return (
        <div className={joinClasses("p-4 bg-white", flat ? "border" : "shadow", className)}>
            {children}
        </div>
    )
};